import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Hero } from '../components/Hero';
import { Reveal } from '../components/Reveal';
import { useContent } from '../ContentContext';
export function Home() {
  const {
    businesses,
    content
  } = useContent();
  return <div className="bg-white" data-id="element-461" data-mp="2x4o5aym1sxn4">
      <Hero data-id="element-462" data-mp="2x4whspe9e0xs" />

      {/* Category grid */}
      <section className="py-24" data-id="element-463" data-mp="1zih2nu9b1fde">
        <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-464" data-mp="1zj8x31r61723">
          <Reveal data-id="element-465" data-mp="24gsa5yc4ndsg">
            <div className="flex items-end justify-between" data-id="element-466" data-mp="24g8w4spll9jp">
              <h2 className="font-display text-3xl font-medium text-gray-900 md:text-4xl" data-id="element-467" data-mp="29g4y6meqiqwm">
                {content.categoriesHeading}
              </h2>
              <Link to="/utbud" className="hidden items-center gap-2 text-sm font-medium text-gray-600 hover:text-black md:flex" data-id="element-468" data-mp="2dii1z59x8eqr">
                Visa alla <ArrowRightIcon className="h-4 w-4" data-id="element-469" data-mp="3kxmreryow84w" />
              </Link>
            </div>
          </Reveal>

          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-470" data-mp="30wrt0rjcmhkt">
            {content.categoryCards.map((card, i) => <Reveal key={card.id} delay={0.1 + i * 0.1} data-id="element-471" data-mp="2vyq8012d486p" data-mpi={i}>
                <Link to={`/utbud?kategori=${encodeURIComponent(card.title)}`} className="group relative block h-80 w-full overflow-hidden rounded-3xl bg-gray-100 shadow-premium transition-all hover:shadow-premium-hover hover:-translate-y-1" data-id="element-472" data-mp="2qylpy6lt35ed">
                  <img src={card.image} alt={card.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-473" data-mp="2d775rwg5wy5q" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" data-id="element-474" data-mp="288drw2wyr551" />
                  <div className="absolute bottom-0 left-0 p-8" data-id="element-475" data-mp="236y7md2m12np">
                    <h3 className="font-display text-3xl font-medium text-white" data-id="element-476" data-mp="1z64ijgdflht8">{card.title}</h3>
                    <p className="mt-2 text-sm text-white/80" data-id="element-477" data-mp="1u9nu0l2bl1fm">{card.subtitle}</p>
                  </div>
                </Link>
              </Reveal>)}
          </div>
        </div>
      </section>

      {/* Partners */}
      <section id="verksamheter" className="bg-gray-50 py-24" data-id="element-478" data-mp="1ok7sa7s1x9j4">
        <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-479" data-mp="1anktdzgjg9ak">
          <Reveal data-id="element-480" data-mp="1flmboi6544kz">
            <h2 className="font-display text-3xl font-medium text-gray-900 md:text-4xl" data-id="element-481" data-mp="1fl4cbco6la8u">{content.partnersHeading}</h2>
            <p className="mt-4 text-lg text-gray-600" data-id="element-482" data-mp="23c9rrqq7m0im">{content.partnersSubheading}</p>
          </Reveal>

          <div className="mt-12 grid gap-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-483" data-mp="2890546amqi0c">
            {businesses.map((business, i) => <Reveal key={business.slug} delay={i * 0.1} data-id="element-484" data-mp="1tjb01zzf1tus" data-mpi={i}>
                <Link to={`/partner/${business.slug}`} className="group flex h-full flex-col overflow-hidden rounded-3xl bg-white shadow-premium transition-all hover:shadow-premium-hover hover:-translate-y-1" data-id="element-485" data-mp="1yjgjisvj8a1s">
                  <div className="relative h-56 overflow-hidden" data-id="element-486" data-mp="2r1kuvev186zx">
                    <img src={business.cover} alt={business.name} className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-487" data-mp="flaj5k7a7c2q" />
                    {business.status === 'coming-soon' && <div className="absolute right-4 top-4 rounded-full bg-black/70 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-white backdrop-blur-md" data-id="element-488" data-mp="od2stsoheh69">
                        Kommer snart
                      </div>}
                  </div>
                  <div className="flex flex-1 flex-col p-8" data-id="element-489" data-mp="3nu100mkh22fs">
                    <div className="flex items-center justify-between" data-id="element-490" data-mp="3nvlwwiu9dxgt">
                      <h3 className="font-display text-2xl font-medium text-gray-900" data-id="element-491" data-mp="5p7fub0p17e7">{business.name}</h3>
                      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-50 text-gray-400 transition-colors group-hover:bg-black group-hover:text-white" data-id="element-492" data-mp="n8f78wc8oky">
                        <ArrowRightIcon className="h-4 w-4" data-id="element-493" data-mp="1c2x4i6x2dzox" />
                      </div>
                    </div>
                    <p className="mt-2 text-sm font-medium text-gray-500" data-id="element-494" data-mp="27fpte9duo78i">{business.services}</p>
                    <p className="mt-4 text-sm leading-relaxed text-gray-600 line-clamp-2" data-id="element-495" data-mp="2cd8527j950k7">{business.description[0]}</p>
                  </div>
                </Link>
              </Reveal>)}
          </div>
        </div>
      </section>
    </div>;
}